import React from 'react';
import CandidatesPageHeader from '../../../components/CandidatesPageHeader';
import UIStrings from '@/Utils/UIStrings';
import useRecruitmentSpec from '../../../api/useRecruitmentSpec';
import AddFromLinkedInButton from './ShortlistFromLinkedIn/AddFromLinkedInButton';

const ShortlistedHeader = () => {
    const { data } = useRecruitmentSpec();

    return (
        <CandidatesPageHeader className="justify-between">
            <div className="flex flex-col">
                <div className="text-left" data-cy="AISearchHeaderTitle">
                    <span className="text-secondary-foreground text-xl font-bold">
                        {`${UIStrings.ShortlistedCandidates} `}
                    </span>
                    <span className="text-secondary-foreground text-xl font-normal">{`${UIStrings.For} `}</span>
                    <span className="text-secondary-foreground text-xl font-bold">{data?.name}</span>
                </div>
                <p className="text-secondary-foreground text-sm">{UIStrings.BelowIsAnOverviewOfAllShortlisted}</p>
            </div>
            <AddFromLinkedInButton />
        </CandidatesPageHeader>
    );
};

export default ShortlistedHeader;
